import moment from 'moment';

export function getTimeDifference({ firstTime, lastTime }) {
  const timeDifference = moment.duration(moment(lastTime).diff(moment(firstTime)));

  return {
    days: timeDifference.days(),
    hours: timeDifference.hours(),
    minutes: timeDifference.minutes(),
  };
}

export function formatTime({ hours, days, minutes }) {
  const times = {
    day: (days) => `${days}d`,
    minutes: (min) => `${min}'`,
    hours: (h) => `${h}h`,
  };

  if (days) return times.day(days);
  if (hours > 0) return times.hours(hours);
  if (minutes === 0) return times.minutes(1);
  return times.minutes(minutes);
}
